export default "__VITE_ASSET__C85ZE64T__"